/**
 * 소속 선택 모달 ($j.Ui.JBModal.target 결합).
 * 본사/지사/센터 selectbox 를 cascade 로 채우고, 선택된 코드를 부모창의 updateSosoks() 로 넘긴다.
 * 레거시 /adm/member/sosok (blade) 대체.
 *
 * 사용법:
 *   $j.Ui.JBModal.target('sosok-modal', {
 *       target: '$j.F.Admin.Member.Sosok',
 *       title:  '소속',
 *       width:  '460px',
 *   });
 *
 * 부모창에 전역 updateSosoks(code) 가 정의되어 있어야 한다 (Pages/Admin/MemberEdit.js).
 * 본사/지사/센터 옵션은 /ajax/sosok?m=bonsa|gisa|center JSON 엔드포인트에서
 * $j.Common.Form 의 helper(registerBonsaHandler, registerGisaHandler, updateBonsaSelectBox)가 로드.
 */
export default class Sosok {
    constructor() { this.$wrap = null; }
    destroy() {}

    init() {
        this.modalId = 'sosok-modal';
        this.render();
        this.bind();
    }

    render() {
        const html = `
        <style>
            .sosok-form .tbx1 { width:100%; border-collapse:collapse; }
            .sosok-form .tbx1 td { background:#fff; padding:8px; text-align:center; }
            .sosok-form select { width:120px; height:30px; }
            .sosok-form .btn-apply { width:100px; height:40px; background:#0a2383; color:#fff; border:none; border-radius:4px; cursor:pointer; }
        </style>
        <div class="sosok-form">
            <div class="tbl_frm01 tbl_wrap">
                <table class="tbx1">
                    <tr><td>
                        <select id="ref-bonsa"><option value="">본사선택</option></select>
                        <select id="ref-gisa"><option value="">지사선택</option></select>
                        <select id="ref-center"><option value="">센터선택</option></select>
                    </td></tr>
                </table>
            </div>
            <div style="text-align:center; margin-top:20px;">
                <button type="button" class="btn-apply">적용</button>
            </div>
        </div>`;
        $(`#${this.id}`).html(html);
        this.$wrap = $(`#${this.id}`);
    }

    bind() {
        const self = this;

        $j.Common.Form.registerBonsaHandler('ref-bonsa', 'ref-gisa', 'ref-center');
        $j.Common.Form.registerGisaHandler('ref-gisa', 'ref-center');
        $j.Common.Form.updateBonsaSelectBox('', 'ref-bonsa', 'ref-gisa', 'ref-center');

        this.$wrap.find('.btn-apply').off('click').on('click', () => self.apply());
    }

    apply() {
        const bsanum = $('#ref-bonsa').val();
        const gsanum = $('#ref-gisa').val();
        const center = $('#ref-center').val();

        if (!bsanum) {
            $('#ref-bonsa').focus();
            $j.F.Admin.Util.tsalert('error', '본사를 선택해주세요.');
            return;
        }
        if (!gsanum) {
            $('#ref-gisa').focus();
            $j.F.Admin.Util.tsalert('error', '지사를 선택해주세요.');
            return;
        }

        const sosokCode = center || gsanum;
        if (typeof window.updateSosoks === 'function') {
            window.updateSosoks(sosokCode);
        }
        $j.Ui.JBModal.close(this.modalId);
    }
}
